import { cn } from '@Utils/cn';

export interface GuestScorecardCounts {
  eaten: number;
  stayed: number;
  played: number;
  celebrated: number;
}

export interface GuestScorecardsProps {
  scorecards: GuestScorecardCounts;
  className?: string;
}

const CARDS: {
  key: keyof GuestScorecardCounts;
  icon: string;
  label: string;
}[] = [
  { key: 'eaten', icon: '🍴', label: 'Eat' },
  { key: 'stayed', icon: '🛏️', label: 'Stay' },
  { key: 'played', icon: '🎫', label: 'Play' },
  { key: 'celebrated', icon: '🎉', label: 'Celebrate' },
];

function Scorecard({
  icon,
  value,
  label,
}: {
  icon: string;
  value: number;
  label: string;
}) {
  return (
    <div className="rounded-lg border border-zinc-200 bg-white px-1 py-2 text-center dark:border-zinc-700 dark:bg-zinc-800">
      <div className="text-base leading-none">{icon}</div>
      <div className="mt-1 text-lg leading-tight font-bold text-zinc-900 dark:text-zinc-100">
        {value}
      </div>
      <div className="text-[10px] font-bold tracking-wide text-zinc-500 uppercase dark:text-zinc-400">
        {label}
      </div>
    </div>
  );
}

/**
 * Lifetime counts of a guest's completed activity. Shared by the shift-report
 * guest card and the fish details Overview tab so both read identically.
 */
export function GuestScorecards({
  scorecards,
  className,
}: GuestScorecardsProps) {
  return (
    <div className={cn('grid grid-cols-4 gap-1.5', className)}>
      {CARDS.map((card) => (
        <Scorecard
          key={card.key}
          icon={card.icon}
          value={scorecards[card.key] ?? 0}
          label={card.label}
        />
      ))}
    </div>
  );
}
